export default __webpack_public_path__ + "static/arindamLehri-f93a2eec57685863a143f6c7cc6e40b3.jpg";